<template>
  <div :class="theme === 'LIGHT' ? 'bg-white' : 'bg-[#191919] text-white'">
    <div class="text-center my-12" v-if="title">
      <h2 class="text-3xl font-medium">{{ title }}</h2>
    </div>
    <Carousel :totalItems="productSkus.length" :theme="theme" v-slot={index,key}>
      <ProductCard class="lg:w-[240px]" :key="key" v-if="productsData" v-bind="productsList[index]!" />
    </Carousel>
  </div>
</template>

<script setup lang="ts">
import Carousel from '../../molecule/carousel/index.vue'
import ProductCard, {type ProductCardProps} from '../../organism/product/card.vue'

interface ProductSkuCarouselProps {
  title?: string;
  products: ProductCardProps[];
  theme: "DARK" | "LIGHT";
}
const {products = [], theme="LIGHT", title} = defineProps<ProductSkuCarouselProps>();
const productSkus = products.map(product => product.sku);
const { data: productsData } = await siteService().fetchProductsBySku(productSkus);
const productsList = computed(() => products.map((product) => {
  if (productsData) {
    const apiProduct = productsData.value?.find(p => p.sku === product.sku)
    return {...apiProduct, ...product}
  } else {
    return product
  }
}))

</script>